import sortBy from 'lodash/sortBy';

import getColorContrast from '../contentFramePortalGateInternalMethods/utils/getColorContrast';

export default function getHighestContrastColor(
  targetRgb: [number, number, number],
  candidateRgbs: [number, number, number][],
): [number, number, number] {
  const sorted = sortBy(candidateRgbs, (candidateRgb) => {
    return -getColorContrast(candidateRgb, targetRgb);
  });
  return sorted[0];
}
